import { scrollSmoothlyToElement } from '@/helpers/scroll'
import { DEFAULT_LANGUAGE } from 'acces-impot-utils/lib/translation'

const ACCES_IMPOT_DOMAIN = 'acces-impot.com'
const ELIO_TAX_DOMAIN = 'elio-tax.com'

const isDev = process.env.NODE_ENV !== 'production'

function isElioTaxDomain(url) {
  return url.hostname.endsWith(ELIO_TAX_DOMAIN)
}

function isAccesImpotDomain(url) {
  return url.hostname.endsWith(ACCES_IMPOT_DOMAIN)
}

export function isInternalUrl(url) {
  if (isDev) return true

  const urlObj = new URL(url)
  return isElioTaxDomain(urlObj) || isAccesImpotDomain(urlObj)
}

export function getPrivacyPagePath(locale) {
  const resolvedLocale = locale || DEFAULT_LANGUAGE
  return `/${resolvedLocale}/privacy`
}

// PDF.js viewer: legacy build from https://github.com/mozilla/pdf.js (legacy/web/viewer.html)
const PDFJS_VIEWER_LATEST_VERSION = 'pdfjs-5.5.207'

export function getPdfViewerUrl(url, version = PDFJS_VIEWER_LATEST_VERSION) {
  const filename = `viewer${isDev ? '-dev' : ''}.html`
  return `/${version}/web/${filename}?file=${encodeURIComponent(url)}`
}

export function hasUrlQuery(urlParam) {
  return process.browser && new RegExp(`[?&]${urlParam}`).test(window.location.href)
}

export function getQueryFromUrl(query) {
  const urlParamMatch = window.location.search.match(new RegExp(`(^|[?&])${query}=([^&#]+)`))
  return urlParamMatch ? urlParamMatch[2] : null
}

export function getAbsoluteUrl(url) {
  return /^\//.test(url) ? 'http://192.168.0.164:5500' + url : url
}

/**
 * @param {string} hash
 * @return {number}
 */
export function getHomeSectionOffset(hash) {
  return hash === '#testimonials' ? -40 : 0
}

export function goToHomeSection(to) {
  if (to.path === this.$route.path) {
    const element = document.querySelector(to.hash)
    if (element) {
      const offset = getHomeSectionOffset(to.hash)
      return scrollSmoothlyToElement(element, {
        isIncludingHeader: false,
        offset,
        speed: 3000,
        minScrollTime: 0.5,
      })
    }
  }
  this.$router.push(to)
}

/**
 * @param {string} query
 * @return {void}
 */
export function removeQueryFromCurrentRoute(query) {
  if (typeof window === 'undefined') return

  const cleanUrl = removeQueryFromPath(window.location.href, query)
  window.history.replaceState(window.history.state, '', cleanUrl)
}

/**
 * @param {string} path
 * @param {string} query
 * @return {string}
 */
export function removeQueryFromPath(path, query) {
  return path.replace(new RegExp(`([?&])${query}(=[^&#]+)?(&?)`), '$1').replace(/(\?|&)($|#)/, '$2')
}
